import Vue from 'vue';
import Router from 'vue-router';
import $store from '../store/index';

import PremiumPage from '../pages/PremiumUpsell.vue';
import LandingPage from '../pages/Home.vue';
import InternationalPage from '../pages/international/International.vue';
import Account from '../pages/Account';
import Info from '../pages/account/Info';
import Feedback from '../pages/account/Feedback';
import Subscriptions from '../pages/account/Subscriptions';
import Discover from '../pages/Discover';
import ListenHome from '../pages/discover/Index.vue';
import Search from '../pages/Search.vue';
import UserLibrary from '../pages/user_library/Index.vue';
import UserLibraryShows from '../pages/user_library/Shows.vue';
import UserLibraryPodcastEpisodes from '../pages/user_library/PodcastEpisodes.vue';
import Bookmarks from '../pages/user_library/Episodes.vue';
import Categories from '../pages/Categories';
import CategoryDetail from '../pages/CategoryDetail';
import ShowDetails from '../pages/ShowDetails';
import EpisodeDetails from '../pages/EpisodeDetails';
import Onboarding from '../pages/Onboarding';
import SignUp from '../pages/onboarding/SignUp';
import Verify from '../pages/onboarding/Verify';
import SignIn from '../pages/onboarding/SignIn';
import ForgotPassword from '../pages/onboarding/ForgotPassword';
import UserInfo from '../pages/onboarding/Info';
import UserCategories from '../pages/onboarding/Categories';
import UserShows from '../pages/onboarding/Shows';
import Complete from '../pages/onboarding/Complete';
import PremiumInfo from '../pages/onboarding/PremiumInfo';
import AdyenBuyPremium from '../pages/onboarding/AdyenBuyPremium';
import Exclusives from '../pages/Exclusives';
import UpdatePassword from '../pages/account/UpdatePassword';
import ResetPassword from '../pages/ResetPassword';
import About from '../pages/About';
import Contact from '../pages/Contact';
import FAQ from '../pages/FAQ';
import IOSThirdParty from '../pages/IOSThirdParty';
import AndroidThirdParty from '../pages/AndroidThirdParty';
import Privacy from '../pages/Privacy';
import Publishers from '../pages/Publishers';
import Terms from '../pages/Terms';
import TermsFreeTrial from '../pages/TermsFreeTrial';
import PremiumShows from '../pages/PremiumShows';
import Careers from '../pages/careers/Careers';
import JobDetail from '../pages/careers/JobDetail';
import PageNotFound from '../pages/404';

function requireAuth(to, from, next) {
  if ($store.getters.loggedIn) {
    next();
  } else if (to.path === '/account/subscription') {
    next({ path: '/signin', query: { redirect: to.fullPath } });
  } else {
    next({ path: '/signup', query: { redirect: to.fullPath } });
  }
}

Vue.use(Router);

const router = new Router({
  linkActiveClass: 'active',
  mode: 'history',
  base: __dirname,
  scrollBehavior() {
    document.querySelector('body').scrollTop = 0;
    return { x: 0, y: 0 };
  },
  routes: [
    { name: 'Premium Page', path: '/premium', component: PremiumPage },
    {
      name: 'Landing Page',
      path: '/',
      beforeEnter: (to, from, next) => {
        if ($store.getters.loggedIn && $store.getters.user) {
          next({ path: '/listen' });
        } else {
          next();
        }
      },
      component: LandingPage,
    },
    {
      name: 'settings_account',
      path: '/account',
      component: Account,
      beforeEnter: requireAuth,
      children: [
        { name: 'My Account - Info', path: 'info', component: Info },
        { name: 'My Account - Feedback', path: 'feedback', component: Feedback },
        { name: 'My Account - Subscriptions', path: 'subscription', component: Subscriptions },
      ],
    },
    {
      path: '/listen',
      component: Discover,
      children: [
        { name: 'home', path: '/', component: ListenHome },
        { name: 'search', path: 'search', component: Search },
        {
          name: 'Library',
          path: '',
          component: UserLibrary,
          children: [
            { name: 'user_shows', path: 'my-shows', component: UserLibraryShows },
            { name: 'user_shows', path: 'my-shows/list', component: UserLibraryPodcastEpisodes },
            { name: 'user_playlist', path: 'bookmarks', component: Bookmarks },
          ],
        },
        { name: 'categories_all', path: 'category', component: Categories },
        {
          name: 'category_detail', path: 'category/:categoryName/:categoryID', component: CategoryDetail, meta: { title: 'categoryPage' },
        },
        {
          name: 'publisher_detail', path: ':publisher_slug/:publisherID', component: CategoryDetail, meta: { title: 'publisherPage' },
        },
        { name: 'show_detail', path: ':publisher_slug/:show_slug/:podcastID', component: ShowDetails },
        { name: 'episode_detail', path: ':publisher_slug/:show_slug/:episode_slug/:episodeID', component: EpisodeDetails },
      ],
    },
    {
      path: '',
      component: Onboarding,
      children: [
        {
          name: 'account_create',
          path: '/signup',
          beforeEnter: (to, from, next) => {
            if ($store.getters.loggedIn && $store.getters.user && $store.getters.user.is_subscribed) {
              next({ path: '/account/subscription' });
            } else if ($store.getters.loggedIn) {
              next({ path: '/premium-buy' });
            } else {
              next();
            }
          },
          component: SignUp,
        },
        { name: 'Verify', path: '/verify', component: Verify },
        { name: 'sign_in', path: '/signin', component: SignIn },
        { name: 'Forgot Password', path: '/forgotPassword', component: ForgotPassword },
        { name: 'onboarding_demographics', path: '/user-info', component: UserInfo },
        { name: 'onboarding_topics', path: '/user-categories', component: UserCategories },
        { name: 'Onboarding Shows', path: '/user-shows', component: UserShows },
        { name: 'Onboarding Complete', path: '/complete', component: Complete },
        { name: 'Premium Info', path: '/premium-info', component: PremiumInfo },
        {
          name: 'Premium Subscribe',
          path: '/premium-buy',
          beforeEnter: requireAuth,
          component: AdyenBuyPremium,
        },
        {
          path: '',
          redirect: '/listen',
        },
      ],
    },
    { name: 'All Exclusives', path: '/exclusives', component: Exclusives },
    {
      name: 'My Account Settings',
      path: '/account',
      component: () => import('../pages/Account'),
      beforeEnter: requireAuth,
      children: [
        { name: 'My Account Settings - Info', path: 'info', component: Info },
        { name: 'My Account Settings - Feedback', path: 'feedback', component: Feedback },
        { name: 'My Account Settings - Subscriptions', path: 'subscription', component: Subscriptions },
      ],
    },
    { name: 'Change Password', path: '/account/updatepassword', component: UpdatePassword },
    { name: 'Password reset', path: '/resetpassword', component: ResetPassword },
    { name: 'About', path: '/about', component: About },
    { path: '/contact', component: Contact },
    { name: 'FAQs', path: '/faqs', component: FAQ },
    { name: 'Third Party Language iOS', path: '/ios-terms', component: IOSThirdParty },
    { name: 'Third Party Language Android', path: '/android-terms', component: AndroidThirdParty },
    { name: 'Privacy', path: '/privacy', component: Privacy },
    { name: 'All Publishers Page', path: '/publishers', component: Publishers },
    { name: 'Terms', path: '/terms', component: Terms },
    { name: 'Terms Free Trial', path: '/termsfreetrial', component: TermsFreeTrial },
    { name: 'Home Screen - Bundle Preview', path: '/bundle/:bundle_id', component: ListenHome },
    { name: 'Premium Upsell', path: '/premium-upsell', component: PremiumPage },
    { name: 'Premium Shows', path: '/shows', component: PremiumShows },
    { name: 'International', path: '/international', component: InternationalPage },
    { name: 'Careers', path: '/careers', component: Careers },
    { name: 'JobDetails', path: '/job/:jobId', component: JobDetail },
    { name: '404', path: '/not-found/404', component: PageNotFound },
    { path: '*', component: PageNotFound },
  ],
});

export default router;



// WEBPACK FOOTER //
// ./app/src/router/index.js